module.exports = __webpack_public_path__ + "f0bec18330fe3c0e6314880cec3fcea5.png";